import React from "react";
import { Link } from "react-router-dom";

const Backlinks = () => {
  let backlinks = [
    {
      webName: "badwap.fun",
      content: "I Thought badwap.fun Was Just a Normal website... Then I Couldn't Stop Watching 😳",
      url: "https://badwap.fun/",
      img:"https://w7.pngwing.com/pngs/111/998/png-transparent-letter-x-illustration-x-mark-check-mark-desktop-x-mark-miscellaneous-angle-flag-thumbnail.png"
    }
  ];

  return (
    <>
     <div className="container my-2">
  <div className="row justify-content-center m-1 g-4 d-flex flex-wrap">
       <h1 className="text-white"> Best Porn Websites</h1>
       
    {backlinks.map((da, index) => (
      <Link
        key={index}
        to={da.url}
        target="_self"
        className="col-12 col-sm-6 col-md-4 col-lg-3 text-decoration-none "
      >
        <div className="card text-black shadow p-3 bg-secondary-subtle">
          <img src={da.img} alt={da.content} />
          <h5>{da.webName}</h5>
          <p>{da.content}</p>
          <a href={da.url} title={da.content} target="_blank”>" >{da.webName}</a>
        </div>
      </Link>
    ))}
  </div>
</div>

    </>
  );
};

export default Backlinks;
